import { render, staticRenderFns } from "./CardDeptReport.vue?vue&type=template&id=1642fa06&"
import script from "./CardDeptReport.vue?vue&type=script&lang=js&"
export * from "./CardDeptReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports